import { forwardRef } from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { flatMap, pipe, entries } from 'remeda';

const rootOptionGroup = '';

const PdSelect = forwardRef(({ disableRootLabel, groupedOptions, value, onOptionClick, ...props }, ref) => {
  const handleOptionClick = (value) => {
    onOptionClick?.(value);
  };

  const SubOptions = pipe(
    entries(groupedOptions),
    flatMap(([header, options]) => {
      const Renders = options.map((option) => (
        <MenuItem
          key={`${props.id}-select-option-${option.value}`}
          value={option.value}
          onClick={() => handleOptionClick(option.value)}
        >
          {option.label ?? option.value}
        </MenuItem>
      ));

      if (header === rootOptionGroup || Renders.length === 0) {
        return Renders;
      }

      return [
        <MenuItem key={`${props.control?.id ?? props?.id ?? 'pd'}-select-group-${header}`} disabled value={header}>
          {header}
        </MenuItem>,
        Renders
      ];
    })
  );

  return (
    <TextField
      {...props}
      inputRef={ref}
      select
      SelectProps={{ displayEmpty: !disableRootLabel, ...props.SelectProps }}
      value={value}
      fullWidth
    >
      <MenuItem disabled value="">
        {props.placeholder}
      </MenuItem>
      {SubOptions}
    </TextField>
  );
});

export default PdSelect;
